var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icon-editor vscroll-wrap vscroll-scroll"},[_c('SingularityPanelHeader',{attrs:{"parentTitle":"Edit Icon","backState":"page_structure"}}),_c('div',{staticClass:"icon-editor-content-wrapper"},[_c('IconInput',{attrs:{"value":_vm.iconInputValue},on:{"input":_vm.updateIconInputValue}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }